import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    chip: {
        '&.MuiChip-root': {
            height: `${theme.spacing(3)}`,
            borderRadius: `${theme.spacing(0.5)}`,
            margin: `0 ${theme.spacing(0.5)}`,
        },
    },
    chipCorrect: {
        '&.MuiChip-root': {
            backgroundColor: theme.colors.gray[0],
            border: `1px solid ${theme.colors.gray[200]}`,
        },
    },
    chipError: {
        '&.MuiChip-root': {
            color: theme.colors.error.main,
            backgroundColor: theme.colors.error.light,
            '& svg': {
                color: theme.colors.error.main,
                '&:hover': {
                    color: theme.colors.error.dark,
                },
            },
        },
    },
    clearIcon: {
        height: theme.spacing(1.5),
        width: theme.spacing(1.5),
    },
    textField: {
        '& .MuiOutlinedInput-root': Object.assign(Object.assign({}, theme.typography.body2), { padding: theme.spacing(0.5) }),
    },
    title: {
        fontFamily: 'Source Sans Pro',
        color: theme.colors.text[700],
        fontSize: theme.spacing(1.75),
        marginBottom: `${theme.spacing(0.25)}`,
    },
}));
//# sourceMappingURL=ChipField.styles.js.map